export const AI_CHAT_NO_RESULTS_RESPONSE_TEXT = 'I couldn\'t find any available placements matching your criteria. Try adjusting your request.';
export const AI_CHAT_ERROR_TEXT = 'Unable to get an AI response. Please try again.';
export const AI_CHAT_CONTEXT_LIMIT_CODE = 'CHAT_CONTEXT_LIMIT_REACHED';
export const AI_CHAT_CONTEXT_LIMIT_TEXT = 'You\'ve reached the context limit for this chat. Start a new conversation to continue.';
export const AI_CHAT_OVERLAY_Z_INDEX = 200002;
export const AI_CHAT_TOOLTIP_Z_INDEX = AI_CHAT_OVERLAY_Z_INDEX + 1;

export const AI_CHAT_COPY = {
  title: 'AI Match',
  panelTitle: 'Flatshow.AI',
  finderLabel: 'Flatshow.AI',
  contextLabel: (complexName: string | null) => (
    complexName ? `Find unit in ${complexName}` : 'Find unit'
  ),
  emptyPrompt: 'Tell me what kind of place you\'re looking for.',
  composerPlaceholder: 'Adjust your criteria…',
  thinking: 'AI is thinking',
  available: 'Available',
  expandResults: 'View all matching placements',
  collapseResults: 'Show fewer placements',
  retry: 'Retry',
  fallbackError: AI_CHAT_ERROR_TEXT,
  contextLimitReached: AI_CHAT_CONTEXT_LIMIT_TEXT,
  openLabel: 'Open Flatshow.AI',
  hideLabel: 'Hide Flatshow.AI',
  minimizeLabel: 'Minimize chat',
  newChatLabel: 'New chat',
  newChatTitle: 'Start a new chat?',
  newChatDescription: 'This will clear your current draft and conversation history.',
  newChatConfirmation: 'Start new chat',
  newChatCancellation: 'Cancel',
  messageLabel: 'Message Flatshow.AI',
  sendLabel: 'Send message',
  recordLabel: 'Record voice message',
  recordingLabel: 'Voice recording',
  stopRecordingLabel: 'Stop recording',
  stopAndTranscribeLabel: 'Stop and transcribe voice message',
  transcribingLabel: 'Transcribing voice message',
  voiceError: 'Unable to record or transcribe audio. Please try again.',
  completedIn: (duration: string) => `Completed in ${duration}`,
  stoppedAfter: (duration: string) => `Stopped after ${duration}`,
  homeLabel: (numeration: string) => `Home ${numeration}`,
  placementLabel: (placementType: string | null, numeration: string) => {
    const normalizedType = placementType?.trim();
    if (!normalizedType || /apartments?|units?|flats?|homes?|квартир|кв\.?/i.test(normalizedType)) {
      return `Home ${numeration}`;
    }
    return `${normalizedType} ${numeration}`;
  },
  apartmentPlanAlt: (numeration: string) => `Apartment ${numeration} plan`,
  placementPlanAlt: (placementType: string | null, numeration: string) => {
    const normalizedType = placementType?.trim();
    if (!normalizedType || /apartments?|units?|flats?|homes?|квартир|кв\.?/i.test(normalizedType)) {
      return `Apartment ${numeration} plan`;
    }
    return `${normalizedType} ${numeration} plan`;
  },
  viewApartmentLabel: (numeration: string) => `View apartment ${numeration}`,
  showPlacementLabel: (placementType: string | null, numeration: string) => {
    const label = AI_CHAT_COPY.placementLabel(placementType, numeration);
    return `Show ${label.charAt(0).toLocaleLowerCase()}${label.slice(1)} in 3D view`;
  },
  viewPlacementLabel: (placementType: string | null, numeration: string) => {
    const normalizedType = placementType?.trim();
    if (!normalizedType || /apartments?|units?|flats?|homes?|квартир|кв\.?/i.test(normalizedType)) {
      return `View apartment ${numeration}`;
    }
    return `View ${normalizedType.toLocaleLowerCase()} ${numeration}`;
  },
  roomsMetadata: (rooms: string) => `${rooms} rooms`,
  floorMetadata: (floor: string) => `Floor ${floor}`,
  buildingMetadata: (building: string) => {
    const trimmedBuilding = building.trim();
    return /^Building(?:\s|$)/i.test(trimmedBuilding) ? trimmedBuilding : `Building ${trimmedBuilding}`;
  },
} as const;

export const getAIChatSuccessResponseText = (totalMatches: number): string => (
  totalMatches === 1
    ? 'I found 1 available layout in this development. Here is the closest match.'
    : `I found ${totalMatches} available layouts in this development. Here are the two closest matches.`
);
